import ApiResponse from "sr/models/ApiResponse";
import { post } from "sr/utils/axios";
import { toast } from "react-toastify";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
export const createStripeConnectOnboarding = async (postData: any) => {
  try {
    return await post<ApiResponse<[]>>(
      "stripepayments/connect/onboarding",
      postData,
    ).then((res) => {
      if (res.success === true) {
        // SuccessMessage('API.SUCCESS.JOBTYPE.UPDATE')
        return res;
      } else {
        toast.error(res.error.message);
        return null;
      }
    });
  } catch (e: any) {
    if (e.response) {
      HandleApiError(e);
      return e.response;
    }
  }
};
